/**
 * Analytics aggregate request (F15).
 *
 * Split from the hook so a test can stub the request by spying on this module,
 * the same reason `dashboard.api` is separate — an internal reference does not
 * go through the export and cannot be intercepted.
 *
 * Lives in `lib/` because two features consume analytics: the analytics screen
 * and the quarterly report, which composes the same figures. Plan §3.1 forbids
 * one feature importing another feature's api.
 *
 * @see docs/plan/IMPLEMENTATION_PLAN.md tasks 10.1, 10.3, §3.1
 */
import type { Analytics } from '@nexus/contracts';

import { api } from './api-client';

export async function getAnalytics(): Promise<Analytics> {
  return api.get<Analytics>('/analytics');
}
